// extracted by mini-css-extract-plugin
export default {"login_form":"styles_login_form__yWJl3"};